import { Box, Typography } from "@mui/material";
import { MONO_FONT_FAMILY } from "@gui/providers/typography";

/** What is typed literally, then what it stands for. */
const SYNTAX = [
	["f:", "field"],
	["g:", "grower"],
	["m:", "farm"],
	["c:", "company"],
	["s:", "status"],
	["n:", "season"],
	['"exact phrase"', ""],
	["-", "exclude"],
] as const;

// Kept as the text's own spaces, so the line wraps between entries and reads the same copied.
const GAP = "  ";

/** One line under the job box's list, on what the box takes beyond words. */
export function JobLookupSyntaxHint() {
	return (
		<Typography
			variant="micro"
			color="text.secondary"
			data-testid="job-search-syntax-hint"
			sx={{ display: "block", px: 2, pb: 1, whiteSpace: "pre-wrap" }}
		>
			{SYNTAX.map(([literal, stands], index) => (
				<Box key={literal} component="span" sx={{ whiteSpace: "nowrap" }}>
					{index > 0 && GAP}
					<Box component="span" sx={{ fontFamily: MONO_FONT_FAMILY }}>
						{literal}
					</Box>
					{stands}
				</Box>
			))}
		</Typography>
	);
}
